<template>
  <div class="page-billConfirm">
    <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form">
      <el-row>
        <el-col :span="6">
          <el-form-item prop="businessLine" label="业务线：">
            <el-select
              filterable
              clearable
              required
              v-model="searchForm.businessLine"
              @change="selectChange"
            >
              <el-option
                v-for="item in businessLineList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="agentName" label="合作商名称：">
            <filter-businessline-partner
              :value.sync="searchForm.supplierId"
              :code.sync="searchForm.supplierCode"
              :businessLine="searchForm.businessLine"
              @initFetch="initPagination('getTableData', true)"
              required
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="regionId" label="合作Region：">
            <filter-businessline-region
              :value.sync="searchForm.regionId"
              style="width: 193px"
              :businessLine="searchForm.businessLine"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item prop="partnerType" label="合作商类型：">
            <el-select filterable required v-model="searchForm.partnerMode">
              <el-option
                v-for="item in partnerTypeList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item prop="regionId" label="账单状态：">
            <el-select filterable clearable v-model="searchForm.status">
              <el-option
                v-for="item in billStatusList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="orderId" label="对账单Id：">
            <el-input clearable v-model.trim="searchForm.settlementOrderNo" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="date" label="账单开始结束日期：">
            <el-date-picker
              v-model="searchDate"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-button type="primary" @click="getTableData('query')" :loading="isLoading"
            >查询</el-button
          >
          <el-button @click="handleExport" :disabled="!tableData.length" :loading="isExportLoading"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-table stripe v-loading="isLoading" :data="tableData">
      <el-table-column prop="supplierCode" label="合作商编号" />
      <el-table-column prop="partnerName" label="合作商名称" />
      <el-table-column prop="partnerModeName" label="合作商类型" />
      <el-table-column prop="settlementNo" label="对账单ID" />
      <el-table-column prop="businessLineDesc" label="业务线" />
      <el-table-column prop="regionName" label="Region" />
      <el-table-column prop="date" label="账单日期" />
      <el-table-column prop="settlementAmount" label="结算金额">
        <template slot-scope="scope">
          <div class="mount-right">{{ scope.row.settlementAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="statusDesc" label="账单状态" />

      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <div class="operate-btn">
            <el-button type="text" @click="handleViewDetail(scope.row)">
              查看
            </el-button>
            <el-button
              v-if="scope.row.status === 10"
              v-auth="'/api/partner/outside/platform/agent/settlementOrder/supplier/confirm'"
              type="text"
              @click="handleViewDetail(scope.row, 'confirm')"
            >
              确认账单
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>

    <el-dialog
      title="账单详情"
      :visible.sync="detailDialogVisible"
      width="60%"
      v-loading="detailLoading"
    >
      <el-descriptions :title="detailObj.partnerName" :column="1" size="medium">
        <el-descriptions-item label="类型">{{ detailObj.partnerModeName }}</el-descriptions-item>
        <el-descriptions-item label="结算状态"
          ><el-tag size="small">正常</el-tag></el-descriptions-item
        >
        <el-descriptions-item label="备注">-</el-descriptions-item>
      </el-descriptions>

      <el-descriptions title="对账单管理" :column="1" size="medium">
        <el-descriptions-item label="对账单ID">{{ detailObj.settlementNo }}</el-descriptions-item>
        <el-descriptions-item label="业务线">{{ detailObj.businessLineDesc }}</el-descriptions-item>
        <el-descriptions-item label="合作Region">{{ detailObj.regionName }}</el-descriptions-item>
        <el-descriptions-item label="账单日期">{{ detailObj.date || '-' }}</el-descriptions-item>
        <el-descriptions-item label="账单状态">{{ detailObj.statusDesc }}</el-descriptions-item>
        <el-descriptions-item label="出账时间">{{ detailObj.createTime }}</el-descriptions-item>
        <el-descriptions-item label="账单确认人">{{ detailObj.confirmMisId }}</el-descriptions-item>
        <el-descriptions-item label="账单确认时间">{{
          detailObj.confirmTime
        }}</el-descriptions-item>
      </el-descriptions>

      <el-descriptions title="账单概览" :column="1" size="medium">
        <el-descriptions-item label="实收流水">{{ detailObj.receivables }}</el-descriptions-item>
        <!-- <el-descriptions-item label="应付商家小计">{{
          detailObj.payablePartnerTotal
        }}</el-descriptions-item>
        <el-descriptions-item label="服务费小计">{{
          detailObj.serviceFeeTotal
        }}</el-descriptions-item>
        <el-descriptions-item label="抵扣费用小计">{{
          detailObj.deductionTotal
        }}</el-descriptions-item> -->
        <el-descriptions-item label="应付商家小计">
          <span>{{ detailObj.payablePartnerTotal }}</span>
          <el-dropdown>
            <span class="el-dropdown-link">
              展开
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>应付商家：{{ detailObj.payablePartner }}</el-dropdown-item>
              <el-dropdown-item
                >实收流水历史欠款：{{ detailObj.payablePartnerAdvance }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-descriptions-item>
        <el-descriptions-item label="服务费小计" v-if="!isQuotaMallType">
          <span>{{ detailObj.serviceFeeTotal }}</span>
          <el-dropdown>
            <span class="el-dropdown-link">
              展开
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in serveFeeObj.detail || []" :key="index">{{
                `${item.label}： ${item.value}`
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-descriptions-item>
        <el-descriptions-item label="抵扣费用小计" v-if="!isQuotaMallType">
          <span>{{ detailObj.deductionTotal }}</span>
          <el-dropdown v-if="detailObj.amountDetail">
            <span class="el-dropdown-link">
              展开
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in deductFeeObj.detail || []" :key="index">{{
                `${item.label}： ${item.value}`
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-descriptions-item>
        <el-descriptions-item label="结算金额">{{
          detailObj.settlementAmount
        }}</el-descriptions-item>
      </el-descriptions>

      <div class="tips" v-if="!isQuotaMallType">
        <h4>特别提示</h4>
        <div>
          1.对账单确认后1个自然日结算至
          <el-link
            type="danger"
            :underline="false"
            href="https://paymp.meituan.com/resource/merchant-wallet/login.html#/"
            target="_blank"
            style="margin-bottom: 5px; color: rgb(21, 106, 240)"
            >商家钱包</el-link
          >
          或对公账户；
        </div>
        <div>2.若对当前对账单有任何疑问，请在7个自然日内，联系渠道经理反馈。</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleBillConfirm"
          v-auth="'/api/partner/outside/platform/agent/settlementOrder/supplier/confirm'"
          v-if="detailObj.status === 10 && dialogMode === 'confirm'"
          :loading="saveLoading"
          :disabled="billConfirmGlobalLock"
          >确认账单</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import { mapState } from 'vuex'
import { subMonths, format } from 'date-fns'
import { lodash } from '@bike/fe-utils'
const quotaMallType = '配额资源商'

// 全局锁变量，防止极限并发下多次请求竞态
let billConfirmGlobalLock = false

export default {
  name: 'billConfirm',
  components: {},
  props: [],
  mixins: [pagination],
  data() {
    return {
      billStatusList: [
        { value: 10, label: '待确认' },
        { value: 20, label: '已确认' },
      ],
      partnerTypeList: [
        { value: 12, label: '资产代理商' },
        { value: 14, label: '配额资源商' },
        { value: 16, label: '资产代理商-资产分期模式' },
      ],
      isLoading: false,
      isExportLoading: false,
      detailDialogVisible: false,
      saveLoading: false,
      detailLoading: false,
      dialogMode: '',
      detailObj: {},
      tableData: [],
      searchDate: [],
      selTableRows: [],
      cacheParams: {},
      deductFeeObj: {},
      serveFeeObj: {},
      searchForm: {
        businessLine: 1203,
        status: '',
        regionId: '',
        settlementOrderNo: '',
        supplierCode: '',
        partnerMode: 12,
      },
      businessLineList: [
        {
          label: '电单车',
          value: 1203,
        },
        {
          label: '单车',
          value: 1204,
        },
      ],
    }
  },
  computed: {
    ...mapState('reconcileBill', ['agentBillStatus', 'agentType']),
    isEbike() {
      return this.searchForm.businessLine === 1203
    },
    isQuotaMallType() {
      return this.detailObj.partnerModeName === quotaMallType
    },
  },
  created() {
    this.init()

    // date
    const startDate = format(subMonths(new Date(), 1), 'yyyy-MM-dd')
    const endDate = format(new Date(), 'yyyy-MM-dd')
    this.searchDate = [startDate, endDate]
  },
  mounted() {},
  methods: {
    getDetailFeeById(obj = {}) {
      const params = {
        settlementOrderNo: obj.settlementNo,
      }
      this.fetch
        .get('getOrderDetailFee', { params })
        .then(res => {
          const nameStr = '抵扣费用小计'
          const serveStr = '服务费小计'

          this.deductFeeObj =
            (res.data || []).find(item => {
              return item.label === nameStr
            }) || {}

          // 服务费
          this.serveFeeObj =
            (res.data || []).find(item => {
              return item.label === serveStr
            }) || {}
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleBillConfirmDebounced: lodash.debounce(async function() {
      // 多重保险：全局变量锁+UI锁防极限并发
      if (billConfirmGlobalLock) return
      billConfirmGlobalLock = true
      if (this.saveLoading) return
      this.saveLoading = true
      try {
        const params = {
          settlementOrderNo: this.detailObj.settlementNo,
        }
        await this.fetch.get('saveBillConfirm', { params })
        this.$message.success('账单确认成功')
        this.detailDialogVisible = false
        this.getTableData()
      } catch (err) {
        this.$message.error('账单确认失败')
        throw err
      } finally {
        billConfirmGlobalLock = false
        this.saveLoading = false
      }
    }, 500),

    handleBillConfirm() {
      this.handleBillConfirmDebounced()
    },
    // handleViewDetail(rowObj = {}, type) {
    //   this.getDetailFeeById(rowObj)
    //   this.detailDialogVisible = true
    //   this.detailLoading = true
    //   this.dialogMode = type

    //   this.detailObj = rowObj
    //   if (rowObj.amountDetail) {
    //     try {
    //       this.detailObj.amountDetail = JSON.parse(rowObj.amountDetail)
    //     } catch (err) {
    //       this.detailObj.amountDetail = rowObj.amountDetail
    //     }
    //   }
    //   setTimeout(() => {
    //     this.detailLoading = false
    //   }, 300)
    // },
    handleViewDetail(rowObj = {}) {
      // 在新标签页中打开账单详情页面，只传递必要的 settlementNo
      const { settlementNo } = rowObj
      const routeData = this.$router.resolve({
        path: '/statement/billConfirm/detail',
        query: { settlementNo },
      })
      window.open(routeData.href, '_blank')
    },
    async handleExport() {
      this.isExportLoading = true
      delete this.cacheParams.pageNo
      delete this.cacheParams.pageSize
      try {
        const res = await this.fetch.get('exportBillConfirm', { params: this.cacheParams })
        this.$message.success(res.data)
      } catch (error) {
        console.error(error)
      } finally {
        this.isExportLoading = false
      }
    },
    async init() {
      this.getDictMap()
    },
    async getDictMap() {
      const params = {
        businessLine: this.searchForm.businessLine,
      }
      const res = await this.fetch.get('reconcileBill_dictMap', { params })
      if (res) {
        const {
          agentBillProcessStatus = {},
          agentType = {},
          agentBillStatus = {},
          // businessLine = {},
        } = res.data
        this.$store.commit(
          'reconcileBill/mu_agentBillProcessStatus',
          agentBillProcessStatus.list || []
        )
        this.$store.commit('reconcileBill/mu_agentType', agentType.list || [])
        this.$store.commit('reconcileBill/mu_agentBillStatus', agentBillStatus.list || [])
        // this.$store.commit('reconcileBill/mu_businessLine', businessLine.list || [])
      }
    },
    async getTableData(type) {
      try {
        type === 'query' && (this.pageNo = 1)
        const [startDate, endDate] = this.searchDate || []
        this.isLoading = true
        const params = {
          startDate,
          endDate,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.searchForm,
        }
        this.cacheParams = params || {}
        const res = await this.fetch.get('getBillConfirmData', { params })
        if (res) {
          const { list, total } = res.data
          this.tableData = list
          this.totalAmount = total
        }
      } catch (err) {
        console.log(err)
        this.tableData = []
        this.totalAmount = 0
      } finally {
        this.isLoading = false
      }
    },
    // 根据业务线变化账单类别/状态
    selectChange(item) {},
  },
}
</script>

<style lang="scss">
.page-billConfirm {
  .tips {
    color: #f56c6c;
  }
  .mount-right {
    width: 50px;
    text-align: right;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    margin-left: 10px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
